import CompliancePill from '../Compliance'
import { ReactComponent as InProgressIcon } from '../../assets/in-progress-dots.svg'
import { ReactComponent as NotStartedIcon } from '../../assets/not-started-dash.svg'
import { Pill } from '../../../../components/stories/Pill'
import { useModuleCopy } from '../../../../context/ModuleContext'

export default function GradesBySection({ sections, isValidating, compliance }) {
  const { textCopy, capitalize } = useModuleCopy()
  return (
    <div className='sections-grading'>
      <div className='header-row'>
        <div className='criteria-title'>
          <h6>{capitalize(textCopy.criteria.label)}</h6>
        </div>
        <div>{process.env.REACT_APP_COMPLIANCE === 'true' ? <h6>Compliance</h6> : ''}</div>
        <div>
          <h6>Status</h6>
        </div>
        <div>
          <h6>Rating</h6>
        </div>
      </div>

      {sections.map(({ id, name, description, currentResponse, valid, optional, notGraded }) => {
        const inProgress = !!currentResponse && currentResponse[0]
        let grade = {
          name: null,
          colour: '#F6F6F6'
        }

        if (optional) grade.name = 'Optional'
        else if (notGraded && valid) grade.name = 'Completed'
        else if (valid) grade = currentResponse?.grade

        const renderStatusPill = () => {
          if (grade?.name)
            return (
              <Pill backgroundColor='#059669' textColor='white'>
                Completed
              </Pill>
            )
          if (inProgress)
            return (
              <Pill backgroundColor='#2563EB' textColor='white'>
                In Progress
              </Pill>
            )
          return (
            <Pill backgroundColor='#E5E7EB' textColor='#374151'>
              Not Started
            </Pill>
          )
        }

        const renderCompliance = () => {
          if (process.env.REACT_APP_COMPLIANCE !== 'true' || !compliance[id]?.denominator) return ''
          if (!!compliance[id]?.denominator) return <CompliancePill {...compliance[id]} />
        }

        return (
          <div className={`theme-row ${!grade?.name && isValidating ? 'incomplete' : ''}`} key={id}>
            <div className='criteria' style={{ display: 'flex', alignItems: 'baseline' }}>
              <h6>{name}</h6>
              <span className='theme-name'>{description}</span>
            </div>

            <div className='compliance'>{renderCompliance()}</div>

            <div className='progress'>{renderStatusPill()}</div>

            <div className='grade'>
              <p>
                {(() => {
                  if (grade?.name) return grade.name
                  else return 'Ungraded'
                })()}
              </p>
              <span
                className='chip'
                style={{
                  backgroundColor: grade?.colour || 'transparent'
                }}
              >
                {!grade && (inProgress ? <InProgressIcon /> : <NotStartedIcon />)}
              </span>
            </div>
          </div>
        )
      })}
    </div>
  )
}
